import Controller from "csi/action/Controller";
import CsiFormData from "csi/action/FormData";
import InformationMessageAggregateController from "csi/action/InformationMessageAggregateController";
import locale from "csi/locale";
import resolver from "csi/resolver";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import _ from "underscore";

const CreateSharedDataSheetsForAgentsController = declare([Controller, InformationMessageAggregateController], {
	successMsg: "",
	displayMsg: "",
	messageRes: "CreateSharedDataSheetsforAgentsInfoMessage",
	bShowProgress: true,

	/**
	 * @override
	 * Atleast one selection is required, display Product Sources that were previously
     * used to create Shared Data Sheets as selected and disabled
	 */
	onFormData(fd: CsiFormData) {
		fd.m_bRequireOne = true;
		fd.m_bOmitSelections = true;
		fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
		return fd;
	},

	/**
	 * determine if BOM.LinkedSourceDataSheets has any data sheet (BOM) whose parent (Product Source) is in aggregation list
	 */
	_isPreSelected: function(/*csi.def.Context*/ctx, /*csi.action.FormData*/fd) {
		const cache = this.m_cache;
		const linkedSourceDataSheetsSet = cache.getNode(this.m_urlNode)?.LinkedSourceDataSheets;
		const productSourcesUsed = [];

		_.each(linkedSourceDataSheetsSet, (ds) => {
			const dataSheet = resolver.resolveNode(ds, true);
			productSourcesUsed.push(dataSheet?.__Parent__);
		});
		const nodeUrl = ctx.getNodeURL();
		return productSourcesUsed?.includes(nodeUrl);
	},

	/**
	 * @override
	 * Post process message to display number of created shared data sheets 
	 */
	postProcessSuccess: function() {
		const nodes = this.m_response.getNodes();
		let createdBOMs = 0;
		_.forEach(nodes, (node) => {
			if (node.$Type === "ApparelBOM" && this.m_cache.getNode(node.__Parent__).$Type ==="ProductSource") {
				createdBOMs++;
			}
		});

		if (createdBOMs == 1) {
			this.displayMsg = locale.resource("CreateSharedDataSheetsSingle_Success", [createdBOMs]);
		} else {
			this.displayMsg = locale.resource("CreateSharedDataSheets_Success", [createdBOMs]);
		}
		// generate success message
		this.successMsg = locale.resource(createdBOMs >= 1 ? this.displayMsg : this.displayMsg, [createdBOMs]);
		return this.inherited(arguments);
	},

	getSuccess: function() {
		return this.successMsg;
	},
});

export = CreateSharedDataSheetsForAgentsController;